import React, { Component, PropTypes } from 'react';
import Media from 'Util/Media';

class IFrameEmbedder extends Component {
  static propTypes = {
    provider: PropTypes.number,
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  render() {
    const { provider, data } = this.props;
    if (provider > 0 && provider < 8) {
      const url = Media.getUrlFromProvider({ provider, id: data });
      return (
        <iframe
          width={730}
          height={730 / 1920 * 1080}
          src={url}
          allowTransparency={true}
          frameBorder={0}
          webkitAllowFullScreen
          mozAllowFullScreen
          allowFullSreen
          oAllowFullScreen
          msAllowFullScreen
        />
      );
    } else if (provider === 8) {
      return (
        <div>
          <div dangerouslySetInnerHTML={{ __html: data }} />
        </div>
      );
    }
    return null;
  }
}

export default IFrameEmbedder;



// WEBPACK FOOTER //
// ./src/js/module/View/IFrameEmbedder.js